import {LanePlanDto} from './LanePlanDto';
import {Comment} from './comment';

export class RunDetails {
  runId: string;
  flowcell: string;
  lab: string;
  largestReadMode: string;
  ngLimsRunId: string;
  runLanes: LanePlanDto[];
  flowCellName: string;
  sequencerType: string;
  runPlannedPuid: string;
  libraryIds: string[];
  flowCellMode: string;
  flowCellType: string;
  planDate: Date;
  _id: string;
  version: number;
  creationDate: Date;
  lastModifiedDate:Date;
  prepareDataForAnalysisDate: Date;
  prepareDataForAnalysisPUID: string;
  sequencingRunStartedDate: Date;
  sequencingRunStartedPUID: string;
  disassembling: boolean;
  runConfigURL: string;
  sampleSheetURL: string;
  sampleSheetURLV2: string;
  analysisSheetFileURL: string;
  comments: Comment[]=[];
  sequencerIntrument: string;
  constraintIds: string[];
  status:string;
  plannedFinishDate: Date;
  unschedulePUID: string;
  unscheduleDateTime: Date;
  runDuration: number;
  sequencingRunFinishedPUID: string;
  sequencingRunFinishedDateTime: Date;
  primaryAnalysisStartedPUID: string;
  primaryAnalysisStartedDateTime: Date;
  primaryAnalysisFinishedPUID: string;
  primaryAnalysisFinishedDateTime: Date;
  runReviewStartedPUID: string;
  runReviewStartedDateTime: Date;
  runReviewFinishedPUID: string;
  runReviewFinishedDateTime: Date;
  actualStartDate: Date;
  actualFinishDate: Date;
  sequencingStarted: boolean;
  redoHistory: string[];
  userEmail: string;
  password: any[];
  transferedToNglimsBy: string;
  transferedToNglimsOn: Date;
  removedLibraries: string[];
  dilutionAndPoolingStartedPUID: string;
  dilutionAndPoolingStartedDateTime: Date;
  dilutionAndPoolingCompletedPUID: string;
  dilutionAndPoolingCompletedDateTime: Date;
  tagLength: string;
  autoQCReportReceived:boolean;
  dpDataExportFileName: string;
  isSampleSheetEventSentToMinnt:boolean;
  gxp:boolean;
  metaDataFileURL: string;
  labName: string;
  flowCellId: string;
}



